import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageLoader from "@/components/PageLoader";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ExportLogistics from "@/pages/ExportLogistics";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import DryVeda from "@/pages/DryVeda";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const [loading, setLoading] = useState(() => !sessionStorage.getItem("ng_loaded"));

  useEffect(() => {
    if (!loading) return;
    const t = setTimeout(() => {
      sessionStorage.setItem("ng_loaded", "1");
      setLoading(false);
    }, 1700);
    return () => clearTimeout(t);
  }, [loading]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="grain min-h-screen bg-forest font-sans text-cream">
        <AnimatePresence>{loading && <PageLoader />}</AnimatePresence>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/export-logistics" element={<ExportLogistics />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/dryveda" element={<DryVeda />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
